import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

// See config here: https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/
const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'local.paren.app',
      'api.staging.paren.app',
      'clownfish-app-6539j.ondigitalocean.app',
      'api.paren.app',
      'webapi.staging.paren.app',
      'webapi.prod.paren.app',
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    ignoreErrors: [
      // Benign: fired when urql aborts an in-flight query's underlying fetch because the
      // component using it unmounted (e.g. navigating away) before the request resolved.
      'AbortError: signal is aborted without reason',
    ],
  });
};

export default initSentry;
